import { render, staticRenderFns } from "./index.vue?vue&type=template&id=51605608&scoped=true&"
import script from "./zPayPaymentReceiptCard.js?vue&type=script&lang=js&"
export * from "./zPayPaymentReceiptCard.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=51605608&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51605608",
  null
  
)

export default component.exports